import { render, staticRenderFns } from "./AddEditItemsPatho.vue?vue&type=template&id=326fc7de"
import script from "./AddEditItemsPatho.vue?vue&type=script&lang=js"
export * from "./AddEditItemsPatho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports